export const TEAM_TEMPLATES = {
  ADD_MEMBER: `Hello, I am requesting to add a new team member:

First Name: [Enter first name]
Last Name: [Enter last name]
Email: [Enter email]
Role: [Manager/Waiter]`,
};

export const getDeleteMemberTemplate = (member: {
  firstName: string;
  lastName: string;
  role: string;
}): string => {
  return `Hello, I am requesting to delete the following user:

First Name: ${member.firstName}
Last Name: ${member.lastName}
Role: ${member.role}`;
};

